import { type CurrentUserIguanaObject } from 'Users';
import { type ProgramFamily } from 'Program';

export const getProgramFamilyApplication = (user: CurrentUserIguanaObject, programFamily: ProgramFamily) =>
    user.programFamilyApplications.find(
        programFamilyApplication => programFamilyApplication.programFamily === programFamily,
    );
